export const PERFIL_LABELS = {
  // Navigation
  administration: 'Administración',
  perfiles: 'Perfiles',

  // Actions
  createPerfil: 'Crear Perfil',
  editPerfil: 'Editar Perfil',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',

  // Form fields
  perfilId: 'ID de Perfil',
  nombrePerfil: 'Nombre del Perfil',

  // Table
  tableId: 'ID',
  tableNombrePerfil: 'Nombre del Perfil',
  tableActions: 'Acciones',

  // Messages
  loadingPerfiles: 'Cargando perfiles...',
  noPerfiles: 'No hay perfiles disponibles',

  // Tooltips
  tooltipEdit: 'Editar perfil',
  tooltipDelete: 'Eliminar perfil'
} as const;
